import React,{ createContext, useState, useEffect } from "react";

import { fetchDataFromApi } from "../utils/api";

export const Context = createContext();

export const AppContext = (props) => {
    const [loading, setLoading] = useState(false);
    const [searchResults, setSearchResults] = useState(false);
    const [selectCategory, setSelectCategory] = useState("New");
    const [mobileMenu, setMobileMenu] = useState(false);

    useEffect(() => {
        fetchSelectCategoriesData(selectCategory)
    }, [selectCategory]);

    const fetchSelectCategoriesData = (query) => {
        setLoading(true);
        fetchDataFromApi(`search/?q=${query}`)
        .then((response) => {
            setSearchResults(response.contents);
            setLoading(false);
        })
        .catch((err) => console.log(err));
    }

    return (
        <Context.Provider value={{
            loading,
            setLoading,
            searchResults,
            setSearchResults,
            selectCategory,
            setSelectCategory,
            mobileMenu,
            setMobileMenu
        }}>
            {props.children}
        </Context.Provider>
    )
}